import { Collection } from "@/models/base/collection";

export class SurveyFormCollection extends Collection {
  constructor() {
    super();
    this.name = "surveyForm";
    this.url = "";
    this.reqParams = {};
  }

  // 設問取得
  async getQuestions(survey_code: string): Promise<any> {
    this.url = "/cms/api/question";
    this.reqParams = { survey_code };
    return await super.fetch();
  }

  // アンケート詳細取得
  async getSurvey(survey_code: string): Promise<any> {
    this.url = "/cms/api/surveyDetail";
    this.reqParams = { survey_code };
    return await super.fetch();
  }
}
